import { render, staticRenderFns } from "./GiftBasketList.vue?vue&type=template&id=3a2cb610&"
import script from "./GiftBasketList.vue?vue&type=script&lang=js&"
export * from "./GiftBasketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports